export default {
  备注: '备注',
  报价单: '报价单',
  协作人: '协作人',
  地址类型: '地址类型',
  新建客户: '新建客户',
  编辑客户: '编辑客户',
  新增商机: '新增商机',
  客户导入: '客户导入',
  转移客户: '转移客户',
  客户规模: '客户规模',
  协议: '协议',
  实缴情况: '实缴情况',
  新增客户: '新增客户',
  开票信息: '开票信息',
  地址信息: '地址信息',
  下级实体: '下级实体',
  下级客户: '下级客户',
  销售合同: '销售合同',
  LP出资信息: 'LP出资信息',
  销售订单: '销售订单',
  资料沉淀: '资料沉淀',
  募资机会: '募资机会',
  详细地址: '详细地址',
  邮政编码: '邮政编码',
  抬头类型: '抬头类型',
  开票抬头: '开票抬头',
  开户银行: '开户银行',
  开户账号: '开户账号',
  开票地址: '开票地址',
  '省份-城市': '省份-城市',
  '省份/城市': '省份/城市',
  商机: '商机',
  基金: '基金',
  产品: '产品',
  基本信息: '基本信息',
  报价单列表: '报价单列表',
  纳税识别号: '纳税识别号',
  关联已有客户: '关联已有客户',
  关联已有: '关联已有',
  新增开票信息: '新增开票信息',
  新增地址信息: '新增地址信息',
  编辑地址信息: '编辑地址信息',
  编辑开票信息: '编辑开票信息',
  线索转化记录: '线索转化记录',
  客户新增成功: '客户新增成功',
  老板委托调研人: '老板委托调研人',
  请输入客户名称: '请输入客户名称',
  协作人查询异常: '协作人查询异常',
  业务归属区域: '业务归属区域',
  确认移除该开票信息: '确认移除该开票信息',
  确认移除该地址信息: '确认移除该地址信息',
  暂无此客户查看权限: '暂无此客户查看权限',
  商机关联客户成功: '商机关联客户成功',
  客户名称是必填项: '客户名称是必填项',
  客户详情EXCEL模板: '客户详情EXCEL模板',
  请先保存客户基本信息: '请先保存客户基本信息',
  请先保存商机基本信息: '请先保存商机基本信息',
  请先保存产品基本信息: '请先保存产品基本信息',
  未成交: '未成交',
  成交一次: '成交一次',
  成交多次: '成交多次',
  未出资: '未出资',
  出资一次: '出资一次',
  出资多次: '出资多次',
  默认地址: '默认地址',
  默认开票信息: '默认开票信息',
  A类: 'A类',
  B类: 'B类',
  C类: 'C类',
  转移: '转移',
  查重: '查重',
  数据查重: '数据查重',
  公司名称: '公司名称'
};
